import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]

import { ref } from "vue";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { useFileManager } from "@/composables/files-manager";
import { useFilesStore } from "@/stores/files.store";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import Popup from "@/components/Popup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFileVersion',
  props: {
  productId: {
    required: true,
    type: [Number, String]
  }
},
  setup(__props) {

const { uploadFileVersion } = useFileManager();
const uiFilesStore = useUIFilesStore();
const filesStore = useFilesStore();

const props = __props;

const fileVersionInput = ref<HTMLInputElement | null>(null);
const fileToUpload = ref<File | undefined>(undefined);

const fetchLocalFile = (): void => {
  if (fileVersionInput.value && fileVersionInput.value.files) {
    fileToUpload.value = fileVersionInput.value.files[0];
  }
};
const handleFileUpload = (): void => {
  if (
    uiFilesStore.fileForNewVersion &&
    !uiFilesStore.fileForNewVersion.is_external &&
    fileToUpload.value
  ) {
    const formData = new FormData();
    formData.append("file", fileToUpload.value);
    formData.append("id", String(uiFilesStore.fileForNewVersion.id));
    uploadFileVersion({
      formData: formData,
      productId: Number(props.productId)
    }).then(() => {
      uiFilesStore.closeAttachmentVersionModal();
    });
  } else {
    console.log("update path for external file");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "data-testing-modal-card": 'upload-file-card',
    onClosePopup: _unref(uiFilesStore).closeAttachmentVersionModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, [
        _createTextVNode(" Upload a new version of "),
        _createElementVNode("i", null, _toDisplayString(_unref(uiFilesStore).fileForNewVersion.name), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("form", {
        id: "upload-file-version",
        onSubmit: _withModifiers(handleFileUpload, ["prevent"])
      }, [
        _createVNode(RightSidebarTitle, { title: 'Select an Attachment:' }),
        _createElementVNode("input", {
          id: "file-version-input",
          ref_key: "fileVersionInput",
          ref: fileVersionInput,
          disabled: _unref(filesStore).areFilesUpdating,
          "data-testing": "file-version-input",
          type: "file",
          onChange: fetchLocalFile
        }, null, 40, _hoisted_1)
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        disabled: !fileToUpload.value || _unref(filesStore).areFilesUpdating,
        class: "btn-1 full-width",
        "data-testing": "upload-file-version-btn",
        form: "upload-file-version"
      }, " Upload new version ", 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})